/*
 * @Date: 2023-11-20 17:04:04
 * @LastEditors: lihwang_wf@126.com
 * @LastEditTime: 2023-12-19 19:06:44
 * @FilePath: /Client/src/components/Signup/const.ts
 * @Description
 */
import { CountriesEnum, countries, Site } from '@/common/const'

interface Value {
  countryPlaceCode?: CountriesEnum;
  loginName?: string;
  gender?: number;
  customerEmail?: string;
  verificationCode?: string;
  // 手机号
  countryCode?: string;
  customerMobile?: string;
  isagree?: boolean;
  recommendationEmail?: string;
  invitationCode?: string;
  recaptchaCode?: string;
  corpName?:string
}

const countryOptions: {
  key: string;
  desc: string;
  nationalFlagUrl: string;
}[] = countries.map((item) => {
  return {
    ...item,
    nationalFlagUrl: `https://static-s.theckb.com/BusinessMarket/Client/${item.key}.png`
  }
})

// 展示站点
const sites = [CountriesEnum.Japan, CountriesEnum.Korea, CountriesEnum.UK]
const siteOptions: {
  key: string;
  desc: string;
  nationalFlagUrl: string;
}[] = countries.filter(i => sites.includes(i.key)).map((item) => {
  return {
    ...item,
    nationalFlagUrl: `https://static-s.theckb.com/BusinessMarket/Client/${item.key}.png`
  }
})

const tips = [
  '请设置用户名',
  '你的名字是？',
  '设置你的登陆密码',
  '请再次输入您的密码',
  '性别',
  '输入邮箱',
  '输入验证码',
  '请输入您的手机号码（选填）',
  '请输入你的Chatwork ID （选填）',
  '请输入你的Skype （选填）',
  '输入Aucfan的注册邮箱',
  '手机号',
  '请输入手机号'
]

export { countryOptions, siteOptions, countries, tips, Value }
